// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { API_URL } from '../../Redux/apiSlice';
// /* endpoints */
// const FILE_UPLOAD_URL = `${API_URL}/file/`;
// const BLOG_URL = `${API_URL}/blog/`; // GET /blog/:id , POST /blog/:id
// const BLOG_URL_FETCH = `${API_URL}/blog/id`; // GET /blog/:id , POST /blog/:id

// export default function BlogEdit() {
//     const { id } = useParams();  // GET BY ID
//     const navigate = useNavigate();

//     const [loading, setLoading] = useState(true);
//     const [blog, setBlog] = useState(null);

//     const [form, setForm] = useState({
//         title: "",
//         excerpt: "",
//         content: "",
//         metaTitle: "",
//         metaDescription: "",
//         metaTags: "",
//         image: null,
//         imagePreview: null,
//         isDraft: true,
//     });

//     const [submitting, setSubmitting] = useState(false);

//     const getAuthHeader = () => {
//         try {
//             const raw = localStorage.getItem("knighthuntToken") || "";
//             const token = raw.trim();
//             if (!token) return null;

//             return token.toLowerCase().startsWith("bearer ")
//                 ? token
//                 : `Bearer ${token} `;
//         } catch {
//             return null;
//         }
//     };

//     /* Fetch Blog By ID */
//     const fetchBlog = async () => {
//         try {
//             const auth = getAuthHeader();

//             const resp = await fetch(`${BLOG_URL_FETCH}/${id}`, {
//                 method: "GET",
//                 headers: {
//                     "Content-Type": "application/json",
//                     ...(auth ? { Authorization: auth } : {}),
//                 },
//                 credentials: "include",
//             });

//             const data = await resp.json();
//             console.log(data);

//             const b = data?.data;

//             if (!b) throw new Error("Blog not found");

//             setBlog(b);

//             setForm({
//                 title: b.title || "",
//                 excerpt: b.excerpt || "",
//                 content: b.content || "",
//                 metaTitle: b.metaTitle || "",
//                 metaDescription: b.metaDescription || "",
//                 metaTags: Array.isArray(b.metaTags) ? b.metaTags.join(", ") : "",
//                 image: null,
//                 imagePreview: b.image || "",
//                 isDraft: b.isDraft ?? true,
//             });
//         } catch (err) {
//             console.error("Fetch blog error:", err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchBlog();
//     }, [id]);

//     /* Select New Image */
//     const onPickImage = (e) => {
//         const file = e.target.files?.[0];
//         if (!file) return;

//         const preview = URL.createObjectURL(file);

//         setForm((prev) => ({
//             ...prev,
//             image: file,
//             imagePreview: preview,
//         }));
//     };

//     /* Upload Image */
//     const uploadWithFetch = async (file) => {
//         const fd = new FormData();
//         fd.append("image", file);

//         const auth = getAuthHeader();
//         const resp = await fetch(FILE_UPLOAD_URL, {
//             method: "POST",
//             body: fd,
//             headers: auth ? { Authorization: auth } : {},
//             credentials: "include",
//         });

//         const body = await resp.json();
//         return body?.response?.url || body?.data?.url || body?.url || "";
//     };

//     /* Update Blog */
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setSubmitting(true);

//         try {
//             let uploadedUrl = blog.image;

//             if (form.image) {
//                 uploadedUrl = await uploadWithFetch(form.image);
//             }

//             const payload = {
//                 id,
//                 title: form.title,
//                 excerpt: form.excerpt,
//                 content: form.content,
//                 metaTitle: form.metaTitle,
//                 metaDescription: form.metaDescription,
//                 metaTags: form.metaTags
//                     ? form.metaTags.split(",").map((t) => t.trim())
//                     : [],
//                 image: uploadedUrl,
//                 isDraft: form.isDraft,
//             };

//             const auth = getAuthHeader();

//             const resp = await fetch(`${BLOG_URL}/${id}`, {
//                 method: "PUT",
//                 headers: {
//                     "Content-Type": "application/json",
//                     ...(auth ? { Authorization: auth } : {}),
//                 },
//                 body: JSON.stringify(payload),
//                 credentials: "include",
//             });

//             const data = await resp.json();

//             if (data?.status) {
//                 alert("Blog updated successfully!");
//                 navigate("/blog-list");
//             } else {
//                 alert(data?.message || "Update failed");
//             }
//         } catch (err) {
//             console.error("Update error:", err);
//             alert("Something went wrong");
//         }

//         setSubmitting(false);
//     };

//     if (loading) return <p>Loading blog...</p>;
//     if (!blog) return <p>Blog not found.</p>;

//     /* UI */
//     return (
//         <div style={{ padding: 20, paddingTop: 100, maxWidth: 700, margin: "0 auto" }}>
//             <form
//                 onSubmit={handleSubmit}
//                 style={{
//                     padding: 20,
//                     borderRadius: 10,
//                     border: "1px solid #d7dde0",
//                     background: "#fafafa",
//                 }}
//             >
//                 {/* Title */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Title *</label>
//                     <input
//                         value={form.title}
//                         onChange={(e) => setForm({ ...form, title: e.target.value })}
//                         required
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     />
//                 </div>

//                 {/* Excerpt */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Excerpt *</label>
//                     <textarea
//                         value={form.excerpt}
//                         onChange={(e) => setForm({ ...form, excerpt: e.target.value })}
//                         rows={2}
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     />
//                 </div>

//                 {/* Content */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Content *</label>
//                     <textarea
//                         value={form.content}
//                         onChange={(e) => setForm({ ...form, content: e.target.value })}
//                         rows={6}
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     />
//                 </div>

//                 {/* Draft */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Draft</label>
//                     <select
//                         value={form.isDraft ? "yes" : "no"}
//                         onChange={(e) =>
//                             setForm({ ...form, isDraft: e.target.value === "yes" })
//                         }
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     >
//                         <option value="yes">Yes (Draft)</option>
//                         <option value="no">No (Publish)</option>
//                     </select>
//                 </div>

//                 {/* Meta Title */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Meta Title</label>
//                     <input
//                         value={form.metaTitle}
//                         onChange={(e) =>
//                             setForm({ ...form, metaTitle: e.target.value })
//                         }
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     />
//                 </div>

//                 {/* Meta Description */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Meta Description</label>
//                     <textarea
//                         value={form.metaDescription}
//                         onChange={(e) =>
//                             setForm({ ...form, metaDescription: e.target.value })
//                         }
//                         rows={3}
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     />
//                 </div>

//                 {/* Meta Tags */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Meta Tags (comma separated)</label>
//                     <input
//                         value={form.metaTags}
//                         onChange={(e) =>
//                             setForm({ ...form, metaTags: e.target.value })
//                         }
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     />
//                 </div>

//                 {/* Image Upload */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Image</label>
//                     <input
//                         type="file"
//                         accept="image/*"
//                         onChange={onPickImage}
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     />

//                     {form.imagePreview && (
//                         <img
//                             src={form.imagePreview}
//                             alt="preview"
//                             style={{
//                                 marginTop: 10,
//                                 width: 100,
//                                 height: 100,
//                                 borderRadius: 8,
//                                 objectFit: "cover",
//                                 border: "1px solid #ccc",
//                             }}
//                         />
//                     )}
//                 </div>

//                 {/* Submit */}
//                 <button
//                     type="submit"
//                     disabled={submitting}
//                     className="btn btn-primary"
//                     style={{ padding: "10px 14px", fontWeight: 600, width: "100%" }}
//                 >
//                     {submitting ? "Updating..." : "Update Blog"}
//                 </button>
//             </form>
//         </div>
//     );
// }



import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { API_URL } from "../../Redux/apiSlice";

/* endpoints */
const FILE_UPLOAD_URL = `${API_URL}/file/`;
const BLOG_URL = `${API_URL}/blog`;
const BLOG_URL_FETCH = `${API_URL}/blog/id`;

export default function BlogEdit() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [blog, setBlog] = useState(null);

    const [form, setForm] = useState({
        title: "",
        excerpt: "",
        content: "",
        metaTitle: "",
        metaDescription: "",
        metaTags: "",
        image: null,
        imagePreview: null,
        isDraft: true,
    });

    const [submitting, setSubmitting] = useState(false);

    const getAuthHeader = () => {
        try {
            const raw = localStorage.getItem("knighthuntToken") || "";
            const token = raw.trim();
            if (!token) return null;

            return token.startsWith("Bearer ") ? token : `Bearer ${token}`;
        } catch {
            return null;
        }
    };

    /* Fetch Blog By ID */
    const fetchBlog = async () => {
        try {
            const auth = getAuthHeader();

            const resp = await fetch(`${BLOG_URL_FETCH}/${id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    ...(auth ? { Authorization: auth } : {}),
                },
                credentials: "include",
            });

            const data = await resp.json();
            const b = data?.data;

            if (!b) throw new Error("Blog not found");

            setBlog(b);

            setForm({
                title: b.title || "",
                excerpt: b.excerpt || "",
                content: b.content || "",
                metaTitle: b.metaTitle || "",
                metaDescription: b.metaDescription || "",
                metaTags: Array.isArray(b.metaTags) ? b.metaTags.join(", ") : "",
                image: null,
                imagePreview: b.image || "",
                isDraft: b.isDraft ?? true,
            });
        } catch (err) {
            console.error("Fetch blog error:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBlog();
    }, [id]);

    /* Select New Image */
    const onPickImage = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const preview = URL.createObjectURL(file);

        setForm((prev) => ({
            ...prev,
            image: file,
            imagePreview: preview,
        }));
    };

    /* Upload Image */
    const uploadWithFetch = async (file) => {
        const fd = new FormData();
        fd.append("image", file);

        const auth = getAuthHeader();
        const resp = await fetch(FILE_UPLOAD_URL, {
            method: "POST",
            body: fd,
            headers: auth ? { Authorization: auth } : {},
            credentials: "include",
        });

        const body = await resp.json();
        return body?.response?.url || body?.data?.url || body?.url || "";
    };

    /* Update Blog */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        try {
            let uploadedUrl = blog.image;

            if (form.image) {
                uploadedUrl = await uploadWithFetch(form.image);
            }

            const payload = {
                id,
                title: form.title,
                excerpt: form.excerpt,
                content: form.content, // CKEDITOR CONTENT
                metaTitle: form.metaTitle,
                metaDescription: form.metaDescription,
                metaTags: form.metaTags
                    ? form.metaTags.split(",").map((t) => t.trim())
                    : [],
                image: uploadedUrl,
                isDraft: form.isDraft,
            };

            const auth = getAuthHeader();

            const resp = await fetch(`${BLOG_URL}/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    ...(auth ? { Authorization: auth } : {}),
                },
                body: JSON.stringify(payload),
                credentials: "include",
            });

            const data = await resp.json();

            if (data?.status) {
                alert("Blog updated successfully!");
                navigate("/blog-list");
            } else {
                alert(data?.message || "Update failed");
            }
        } catch (err) {
            console.error("Update error:", err);
            alert("Something went wrong");
        }

        setSubmitting(false);
    };

    if (loading) return <p>Loading blog...</p>;
    if (!blog) return <p>Blog not found.</p>;

    return (
        <div style={{ padding: 20, paddingTop: 100, maxWidth: 700, margin: "0 auto" }}>
            <form
                onSubmit={handleSubmit}
                style={{
                    padding: 20,
                    borderRadius: 10,
                    border: "1px solid #d7dde0",
                    background: "#fafafa",
                }}
            >
                {/* Title */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Title *</label>
                    <input
                        value={form.title}
                        onChange={(e) => setForm({ ...form, title: e.target.value })}
                        required
                        className="form-control"
                        style={{ marginTop: 6 }}
                    />
                </div>

                {/* Excerpt */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Excerpt *</label>
                    <textarea
                        value={form.excerpt}
                        onChange={(e) =>
                            setForm({ ...form, excerpt: e.target.value })
                        }
                        rows={2}
                        className="form-control"
                        style={{ marginTop: 6 }}
                    />
                </div>

                {/* Content - CKEDITOR FIX */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Content *</label>

                    <CKEditor
                        editor={ClassicEditor}
                        data={form.content}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            setForm((prev) => ({ ...prev, content: data }));
                        }}
                    />
                </div>

                {/* Draft */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Draft</label>
                    <select
                        value={form.isDraft ? "yes" : "no"}
                        onChange={(e) =>
                            setForm({ ...form, isDraft: e.target.value === "yes" })
                        }
                        className="form-control"
                        style={{ marginTop: 6 }}
                    >
                        <option value="yes">Yes (Draft)</option>
                        <option value="no">No (Publish)</option>
                    </select>
                </div>

                {/* Meta Title */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Meta Title</label>
                    <input
                        value={form.metaTitle}
                        onChange={(e) =>
                            setForm({ ...form, metaTitle: e.target.value })
                        }
                        className="form-control"
                        style={{ marginTop: 6 }}
                    />
                </div>

                {/* Meta Description */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Meta Description</label>
                    <textarea
                        value={form.metaDescription}
                        onChange={(e) =>
                            setForm({ ...form, metaDescription: e.target.value })
                        }
                        rows={3}
                        className="form-control"
                        style={{ marginTop: 6 }}
                    />
                </div>

                {/* Meta Tags */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Meta Tags</label>
                    <input
                        value={form.metaTags}
                        onChange={(e) =>
                            setForm({ ...form, metaTags: e.target.value })
                        }
                        className="form-control"
                        style={{ marginTop: 6 }}
                    />
                </div>

                {/* Image */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Image</label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={onPickImage}
                        className="form-control"
                        style={{ marginTop: 6 }}
                    />

                    {form.imagePreview && (
                        <img
                            src={form.imagePreview}
                            alt="preview"
                            style={{
                                marginTop: 10,
                                width: 100,
                                height: 100,
                                borderRadius: 8,
                                objectFit: "cover",
                                border: "1px solid #ccc",
                            }}
                        />
                    )}
                </div>

                {/* Submit */}
                <button
                    type="submit"
                    disabled={submitting}
                    className="btn btn-primary"
                    style={{ padding: "10px 14px", fontWeight: 600, width: "100%" }}
                >
                    {submitting ? "Updating..." : "Update Blog"}
                </button>
            </form>
        </div>
    );
}
